import apinode from '../../apinode'

class ImagensService {
  constructor() {
    this.idconta = localStorage.idconta
    this.controller = new AbortController()
    this.api = apinode.interceptors.request.use((config) => {
      config.signal = this.controller.signal

      return config
    })
  }

  cancelRequest() {
    this.controller.abort()

    this.controller = new AbortController()
  }

  async getAllByProductId(idProduto) {
    console.log({ idProduto })
    const response = await apinode.get(`/imagens/${this.idconta}/${idProduto}`)

    return response.data
  }

  async create(data) {
    await fetch(`${process.env.REACT_APP_IMAGE_URL_API}/${this.idconta}`, {
      method: 'POST',
      body: data,
    })
  }

  async updateImgApp(id) {
    await apinode.patch(`/imagens/${this.idconta}/${id}`)
  }

  async delete(id) {
    await apinode.delete(`/imagens/${this.idconta}/${id}`)
  }

  async deleteAll(productId) {
    await apinode.delete(`/imagens/${this.idconta}/${productId}/all`)
  }
}

export default new ImagensService()
